
import hcbSwordImg from '../../../images/itemImg/hcbsword.jpg';
import MpImg from '../../../images/itemImg/MP.jpg';
import beerImg from '../../../images/itemImg/beer.jpg';
import drugonEggImg from '../../../images/itemImg/drugonegg.jpg';
import roseImg from '../../../images/itemImg/rose.jpg';
import shieldImg from '../../../images/itemImg/shield.jpg';
import telescopeImg from '../../../images/itemImg/telescope.jpg';
import warpImg from '../../../images/itemImg/warp.jpg';
import reverseImg from '../../../images/itemImg/reverse.png';
import treasureImg from '../../../images/itemImg/treasure.png';
import resetImg from '../../../images/itemImg/reset.jpg';
import { getUserData } from '../../../database/getUserData';
import { useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { levelState } from '../../../globalStates/general/level';

export const itemData = {
  0: {
    name: "ハニカムソード",
    spendMp: 10,
    needPoint: ["easy", 30], // 獲得に必要なポイント
    isOnce: true,
  },
  1: {
    name: "魔法のほうき",
    spendMp: 40,
    needPoint: ["easy", 25],
    isOnce: false,
  },
  2: {
    name: "リバース",
    spendMp: 20,
    needPoint: ["easy", 15],
    isOnce: false,
  },
  3: {
    name: "リセットボタン",
    spendMp: 25,
    needPoint: ["normal", 35],
    isOnce: false,
  },
  4: {
    name: "sample: 4",
    spendMp: 20,
    needPoint: ["hard", 125],
    isOnce: false,
  },
  5: {
    name: "sample: 5",
    spendMp: 15,
    needPoint: ["easy", 130],
    isOnce: false,
  },
  6: {
    name: "sample: 6",
    spendMp: 10,
    needPoint: ["easy", 120],
    isOnce: false,
  },
  7: {
    name: "MPボーション",
    spendMp: 10,
    needPoint: ["hard", 35],
    isOnce: true,
  },
  8: {
    name: "宝箱",
    spendMp: 0,
    needPoint: ["hard", 37],
    isOnce: true,
  },
  9: {
    name: "sample 9",
    spendMp: 0,
    needPoint: ["easy", 120],
    isOnce: true,
  },
  10: {
    name: "sample 10",
    spendMp: 0,
    needPoint: ["easy", 120],
    isOnce: true,
  },
  11: {
    name: "sample 11",
    spendMp: 0,
    needPoint: ["easy", 120],
    isOnce: true,
  },
  12: {
    name: "sample 12",
    spendMp: 0,
    needPoint: ["easy", 120],
    isOnce: true,
  },
  13: {
    name: "13",
    spendMp: 0,
    needPoint: ["normal", 130],
    isOnce: false,
  },
  14: {
    name: "ドラゴンの卵",
    spendMp: 90,
    needPoint: ["normal", 30],
    isOnce: true,
  },
  15: {
    name: "青いバラ",
    spendMp: 120,
    needPoint: ["normal", 30],
    isOnce: false,
  },
  16: {
    name: "sample 16",
    spendMp: 0,
    needPoint: ["normal", 130],
    isOnce: false,
  },
}

// 未取得のアイテム配列専用
const sortArray = (arr) => {
  for (let i = 0; i < arr.length; i++) {
    for (let j = 0; j < arr.length - i - 1; j++) {
      if (arr[j][2][1] > arr[j + 1][2][1]) {
        [arr[j], arr[j + 1]] = [arr[j + 1], arr[j]];
      }
    }
  }
  return arr;
}

export const donotHaveItemArr = async (level) => {
  const url_string = window.location.href;
  const url = new URL(url_string);

  let tmpArr = [];
  let userItemArr = [];
  await getUserData().then((data) => {
    userItemArr = data.itemList
  })
  for (let i = 0; i < Object.keys(itemData).length; i++) {
    if (!userItemArr.includes(i)) {
      // レベルによって得られるアイテムが違う
      if (level === itemData[i].needPoint[0]) tmpArr.push([i, itemData[i].name, itemData[i].needPoint]);
    }
  }
  if (tmpArr.length === 0) {
    return [];
  }
  return sortArray(tmpArr);
}

export const manageItemImg = {
  hcSwordImg: hcbSwordImg,
  mpImg: MpImg,
  beerImg: beerImg,
  drugonEggImg: drugonEggImg,
  roseImg: roseImg,
  shieldImg: shieldImg,
  telescopeImg: telescopeImg,
  warpImg: warpImg,
  reverseImg: reverseImg,
  resetImg: resetImg,
}
export const itemIdToImg = (id) => {
  switch (id) {
    case 0:
      return hcbSwordImg;

    case 1:
      return warpImg;

    case 2:
      return reverseImg;

    case 3:
      return resetImg;

    case 7:
      return MpImg;
    case 8:
      return treasureImg;
    case 14:
      return drugonEggImg;

    case 15:
      return roseImg;

  }
}
